import { Font } from '../constants';

export type FontInfo = {
  name: string;
  value: Font;
  category: 'sans-serif' | 'serif' | 'monospace' | 'cursive';
  hasItalics: boolean;
  label: string;
};

export const AVAILABLE_FONTS: Array<FontInfo> = [
  { name: 'Inter', value: Font.inter, category: 'sans-serif', hasItalics: true, label: 'Neutral (Default)' },
  { name: 'Merriweather', value: Font.merriweather, category: 'serif', hasItalics: true, label: 'Editorial' },
  { name: 'Montserrat', value: Font.montserrat, category: 'sans-serif', hasItalics: true, label: 'Urban / Bold' },
  { name: 'Poppins', value: Font.poppins, category: 'sans-serif', hasItalics: true, label: 'Trendy / Bouncy' },
  { name: 'Nunito', value: Font.nunito, category: 'sans-serif', hasItalics: true, label: 'Soft / Friendly' },
  {
    name: 'Playfair Display',
    value: Font.playfairDisplay,
    category: 'serif',
    hasItalics: true,
    label: 'Luxury Display',
  },
  { name: 'Lora', value: Font.lora, category: 'serif', hasItalics: true, label: 'Elegant / Flowy' },
  { name: 'Bitter', value: Font.bitter, category: 'serif', hasItalics: true, label: 'Sturdy Slab' },
  { name: 'Barlow', value: Font.barlow, category: 'sans-serif', hasItalics: false, label: 'Condensed / Impact' },
  { name: 'IBM Plex Sans', value: Font.ibmPlexSans, category: 'monospace', hasItalics: true, label: 'Code / Tech' },
  { name: 'Patrick Hand', value: Font.patrickHand, category: 'cursive', hasItalics: false, label: 'Handwritten' },
  { name: 'Sora', value: Font.sora, category: 'sans-serif', hasItalics: false, label: 'Innovation / Tech' },
];

export const getGoogleFontUrl = (fontName: string, hasItalics: boolean): string => {
  const formattedName = fontName.trim().replace(/\s+/g, '+');
  const weights = [400, 500, 600, 700];
  let weightStr = '';

  if (hasItalics) {
    const uprights = weights.map((w) => `0,${w}`);
    const italics = [`1,400`, `1,700`];
    const allVariants = [...uprights, ...italics].sort();
    weightStr = `:ital,wght@${allVariants.join(';')}`;
  } else {
    weightStr = `:wght@${weights.join(';')}`;
  }
  return `https://fonts.googleapis.com/css2?family=${formattedName}${weightStr}&display=swap`;
};
